<div ngClass="wf-diagram-connector-{{direction}}" class="wf-diagram-connector-border" *ngIf="hasParent"></div>
<div class="wf-diagram-block-box cs-d-flex align-items-center view-mode-{{viewMode}}" [ngClass]="{'audit-highlight': isAuditHightlight}">
    <div class="cs-flex-1 pos-rlt task-status-{{ taskStatus['status'] }} task-audit-{{ nodeOptions.audit?.eventId }}">
        <button class="add-node-btn cursor-pointer" type="button" *ngIf="nodeOptions.showAddChild && !isNew" (click)="addNode()">
            <img [src]="iconImageUrl" alt="{{isNew}}"/>
        </button>
        <ng-container *ngTemplateOutlet="initializerTemplate; context:{
            nodeOptions:nodeOptions,
            isNew:isNew,
            blockHeaderText: blockHeaderText
        }"> </ng-container>
    </div>
</div>
<div ngClass="wf-diagram-connector-{{direction}}" class="wf-diagram-connector-border" *ngIf="node?.children?.length"></div>

<ng-template #cs_initializer let-isNew="isNew" let-nodeData="node" let-headerText="blockHeaderText">
    <div [id]="id"
         [@highlightNodeAdded]="onHighlight" (@highlightNodeAdded.done)="onHighlight=''"
         class="task-block cs-initializer-block cs-d-flex flex-column align-items-center" [ngClass]="{'is-new': isNew}">
        <div *ngIf="!isNew" class="pos-abt-full cursor-pointer task-action-link" (click)="editNode()"></div>
        <div class="node-heading">How do you want to trigger this workflow? </div>
        <div class="node-content m-t--10">{{ nodeSubTitlePrefix }} <br/><span class="font-bold">{{nodeOptions.metaData.name}}</span></div>
        <div class="node-content m-t--10" *ngIf="isNew">
            <button class="btn btn-link" type="button" (click)="showTriggerPanel()" translate>Click to add conditions</button>
        </div>
        <ng-container *ngFor="let rule of rules; let idx = index; let isLast = last; let isFirst = first;">
            <div class="node-content cs-d-flex cs-d-flex-wrap justify-content-center" [ngClass]="{'m-t--10': isFirst}">
                <div class="font-bold">{{ rule['text'] }}</div>
                <div class="m-l--5 m-r--5"> {{ operatorsDisplayText[rule['operator']] }}</div>
                <div class="font-bold">{{ getValue(rule['col_name'], rule['value']) }}</div>
            </div>
            <div *ngIf="!isLast" class="cs-d-flex cs-d-flex-wrap justify-content-center">
                <div>and</div>
            </div>
        </ng-container>
    </div>
</ng-template>

<app-common-modal-popups *ngIf="statusConfirmationModalConfig?.showModal"  [modalConfig]="statusConfirmationModalConfig"></app-common-modal-popups>
